module.exports = __webpack_public_path__ + "img/Kart 3.jpeg";